'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator'),
    util = require('./util'),
    tealium = require('../../../int_tealium/cartridge/js/tealium/tealium');

function getSocialSignInVendor(providerId) {
    if (!providerId) {
        return '';
    }
    if (String(providerId).indexOf('Google') !== -1) {
        return 'Google';
    } else if (providerId === 'Apple' || providerId === 'AppleWebSignIn') {
        return 'Apple';
    }
    return 'Facebook';
}

function triggerSocialSignInInitiation(oAuthIcon, providerId) {
    var vendor = getSocialSignInVendor(providerId);
    var payload;

    if (oAuthIcon.socialSignInInitiationTracked || !vendor || !window.utag_data) {
        return;
    }

    oAuthIcon.socialSignInInitiationTracked = true;
    payload = {
        event_name: 'social_sign_in_initiation',
        sign_in_initiation_brand: String(window.utag_data.current_brand || '').toUpperCase(),
        sign_in_initiation_vendor: vendor
    };

    tealium.triggerEvent(payload);
}

function forgetPasswordCallback() {
    validator.init();	
    var $requestPasswordForm = $('[name$="_requestpassword"]');
    var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
    $('body').off('click','[name$="_requestpassword"] [name$="_requestpassword_send"]').on('click','[name$="_requestpassword"] [name$="_requestpassword_send"]', function (e) {
        if (!$requestPasswordForm.valid()) {
            return;
        }
        e.preventDefault();
        var data = $requestPasswordForm.serialize();
        // add form action to data
        data += '&' + $submit.attr('name') + '=';
        // make sure the server knows this is an ajax request
        if (data.indexOf('ajax') === -1) {
            data += '&format=ajax';
        }
        $.ajax({
            type: 'POST',
            url: $requestPasswordForm.attr('action'),
            data: data,
            success: function (response) {
                if (typeof response === 'object' &&
                        !response.success &&
                        response.error === 'CSRF Token Mismatch') {
                    page.redirect(Urls.csrffailed);
                } else if (typeof response === 'string') {
					dialog.$container.html(response);
					if($requestPasswordForm.length>0){
						forgetPasswordCallback();
						util.updateInputFields();
					}
                    /* WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                }
            },
            failure: function () {
                dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                /* WCAG_Modal_focus_management */
            	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                	$(this).focus();
                });
                $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
            }
        });
    });
    $('.close-button').on('click', function(e){
    	e.preventDefault();
    	$(this).closest('.ui-dialog').find('.ui-dialog-titlebar-close').trigger('click');
    });
    $('html').bind('click',function(e){
    	if($('.wrapper-forgot-password').closest('.ui-dialog').hasClass('forgot-password')&& !$(e.target).is('.ui-dialog, a')&& !$(e.target).closest('.ui-dialog').length) {
    		$('.forgot-password').find('.ui-dialog-titlebar-close').trigger('click');
    	}
    });
}
var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
    	
		// Let's make sure that this library only gets initialized one as we're
		// also initializing from app.js for non-login / account pages
		if (this.hasOwnProperty("initialized")) { return; }
		
		// Default that initialization has taken place
		this.initialized = true;
		
		// o-auth binding for which icon is clicked
        $('body').off('click', '.oAuthIcon').on('click', '.oAuthIcon', function () {
            // We have multiple login forms on some pages, so scope to the clicked form.
            var $form = $(this).closest('form');
            var $OAuthProvider = $form.find('input[name="OAuthProvider"]');
            var $socialLoginReferrer = $form.find('input[name="socialLoginReferrer"]');
            var socialLoginReferrer = document.referrer || '__EMPTY_REFERRER__';

			// Once we have that, set the OAuth provider
			$OAuthProvider.val(this.id);
            triggerSocialSignInInitiation(this, this.id);
            if ($socialLoginReferrer.length) {
                $socialLoginReferrer.val(socialLoginReferrer);
            }

		});

        $('body').off('click.appleSignIn', '.social-icons#Apple').on('click.appleSignIn', '.social-icons#Apple', function (e) {
            e.preventDefault();

            var $form = $(this).closest('form');
            var storehref = $form.data('storehref');
            var $appleSignIn = $('#appleid-signin');

            if (storehref) {
                $.ajax({
                    url: storehref,
                    method: 'POST',
                    data: location.href
                });
            }

            if ($appleSignIn.length) {
                $appleSignIn.trigger('click');
            }
        });

        // toggle the value of the remember-me checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });

        function passwordResetNotifyClose() {
            if($('#header').hasClass('has-reset-header')){
                $('#header').removeClass('has-reset-header');
            }
            $('.reset-message-notify').hide();
        }
        
        // hide reset password success message box
        $(document).on('click', '.closeMsg', function(){
            passwordResetNotifyClose();
        });

        $('body').on('keyup', '.closeMsg', function(e){
            if (e.key === 'Enter') {
                passwordResetNotifyClose();
            }
        });
        
        $("body").off('click','.password-reset').on('click','.password-reset', function (e) {
        		e.preventDefault();
           	 	dialog.open({
                    url: $(e.target).attr('href'),
                    options: {
                    	width: 432,
                    	dialogClass: 'forgot-password',
                        open: function () {
                            forgetPasswordCallback();
                            if ($('#wrapper').hasClass('pt_checkout') && localStorage.getItem('emailSubmitted') !=null) {
                                $('.forgot-password .make-label-absolute').find('input[type="text"]').val(localStorage.getItem('emailSubmitted'));
                            }else if(localStorage.getItem('emailSubmitted') !=null){
                        		$('.forgot-password .make-label-absolute').find('input[type="text"]').val(localStorage.getItem('emailSubmitted'));
                        	}
                       	 /* PXSFCC-4495_WCAG_Modal_focus_management */
                        	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                            	$(this).focus();
                            });
                        	
                            $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                        },
                        close: function(e){
                        	$(".ui-dialog.forgot-password").removeClass('forgot-password');
                            dialog.close();
                            if(window.lastClickOrKey === 'key'){
                                $('#password-reset.password-reset').focus().addClass('focus-outline');
                            }
                        }
                    }
               });
        });
        
        /**
         * @function
         * @description updates focus | WCAG login/Sign in validation on focus
         */
       var $loginForm = $('.login-form');
       $('body').off('keydown keypress click mousedown','.login-form .spc-login-btn').on('keydown keypress click mousedown','.login-form .spc-login-btn', function (e) {
           if((e.keyCode && e.keyCode == 13)){
        	   util.validateLoginOnSubmit($loginForm);
           }
       });
       $('body').off('blur').on('blur','.login-form .form-row.username .input-text.email', function (e) {   
    	   util.validateEmailOnFocusOut($loginForm);
       });
       $('body').off('blur').on('blur','.login-form .form-row.password .input-text.password', function (e) {   
    	   util.validatePasswordOnFocusOut($loginForm); 
       });
       $('body').off('input','.login-form .form-row.username .input-text.email').on('input','.login-form .form-row.username .input-text.email', function() { 
	    	$('.login-form').find('.usernameError, .errorInvalidEmail').addClass('hide');
		});
       $('body').off('input','.login-form .form-row.password .input-text.password').on('input','.login-form .form-row.password .input-text.password', function() {  
    	   $('.login-form').find('.passwordError ').hide();
		}); 
    }
}

module.exports = login;
